const users = {
  pageName: 'Usuários',
  mainTabs: {
    titleInvitations: 'Convites',
    titleExistingUsers: 'Usuários Existentes',
  },
  headerButtons: {
    invite: {
      inviteBtn: 'Convidar',
    },
  },
  toast: {
    error: {
      default: 'Ocorreu um erro desconhecido.',
      badResponse: 'Resposta do usuário inválida do servidor',
      create: {},
      edit: {
        change: 'Senha anterior incorreta',
      },
      unauthorized: 'Operação não autorizada.',
    },
    success: {
      delete: {
        default: 'Usuário excluído com sucesso',
      },
      create: {
        default: 'O usuário foi criado com sucesso.',
      },
      edit: {
        change: 'Senha alterada',
        default: 'Usuário atualizado.',
      },
      reset: {
        default: 'O e-mail de Redefinição de Senha foi enviado com sucesso.',
      },
    },
  },

  deleteModal: {
    header: 'Excluir usuários',
    body: 'Você está prestes a excluir {{num}} usuários.',
  },

  create: {
    alreadyExistToast: {
      message: 'Ocorreu um erro. O e-mail já existe. Por favor, tente um e-mail diferente.',
    },
    errorRequestToast: {
      message: 'Proibido. Você não tem permissões para realizar esta ação. Entre em contato com um administrador.',
    },
    successToast: {
      message: 'Sucesso! Usuário criado com sucesso',
    },
    validations: {
      firstName: 'Nome é obrigatório',
      lastName: 'Sobrenome é obrigatório',
      phone: {
        invalid: 'O telefone é inválido',
        required: 'O telefone é obrigatório',
        length: 'O telefone deve conter de 6 a 16 dígitos',
      },
      email: {
        required: 'E-mail é obrigatório',
        email: 'Endereço de e-mail inválido',
      },
      role: {
        required: 'A função é obrigatória',
      },
      supplier: {
        required: 'Requer-se fornecedor',
      },
    },
  },
  select: 'Selecione',
  edit: {
    modalRemoveConfirm: {
      header: 'Aviso!',
      body: 'Você tem certeza que deseja excluir este usuário? Nota: se associado a outros locais, o usuário será removido do local atual apenas.',
      modalRemoveConfirmBtn: 'Remover',
    },
    formTabs: {
      informationTab: 'Informação',
      notesTab: 'Observações',
      historyTab: 'Histórico',
    },
  },

  table: {
    filters: {
      role: 'Função',
    },
    headers: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      role: 'Função',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },
  isCompanyAdmin: 'Administrador de empresa',

  form: {
    header: {
      createUser: {
        title: 'Criar',
      },

      updateUser: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    selectOption: {
      select: 'Selecione',
    },
    information: {
      details: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: 'Nome',
          lastName: 'Sobrenome',
          name: 'Nome',
          phone: 'Telefone',
          email: 'E-mail',
          site: 'Local',
        },
      },
      roles: {
        header: 'Locais e funções',
        fields: {
          role: 'Função',
          site: 'Local',
        },
        buttons: {
          addAccess: 'Adicionar Local',
        },
      },
      actions: {
        header: 'Ações',
        buttons: {
          delete: 'Remover',
          resetPassword: 'Redefinir Senha',
          changePassword: 'Alterar senha',
        },
      },
    },
    valdations: {
      firstName: 'Nome é obrigatório',
      lastName: 'Sobrenome é obrigatório',
      phone: 'O telefone é obrigatório',
      supplier: 'Requer-se fornecedor',
      role: 'A função é obrigatória',
      email: {
        required: 'E-mail é obrigatório',
        email: 'Endereço de e-mail inválido',
      },
    },
  },
};

export default users;
